import { Auth } from 'aws-amplify';
import { useContext } from 'react';
import { CoreContext } from '@genflow/core';

export default (debug) => {
    const config = useContext(CoreContext);
    const { vendorUuid } = config;

    const login = async (email, password) => {
        const emailWithVendor = `${email.toLowerCase().trim()}#${vendorUuid}`;
        const response = await Auth.signIn(emailWithVendor, password);
        if (debug) {
            console.log('useLogin login response: ', response);
        }
        return true;
    };
    return login;
};
